import React from "react";
import TextMessage from "./TextMessage";

const ContactDataCollector = (props) => {
	const { content, collectorState, recordId } = props;
	const showPromptMessage = content?.config?.message;
	const isCurrentCollector = collectorState?.recordId === recordId;

	return (
		<>
			{/* Always render the initial prompt */}
			{showPromptMessage && (
				<TextMessage 
					content={{ config: { message: showPromptMessage } }}
				/>
			)}

			{/* Render attrs only for the active collector record */}
			{isCurrentCollector &&
				collectorState?.innerAttrs?.map((attr, i) => {
					const isCurrent = attr.field === collectorState.currAttr?.field;
					const isFilled = !!attr.value;

					if (isFilled || isCurrent) {
						return (
							<TextMessage
								isAttr={true}
								key={`contact-attr-${i}-${attr.field}`}
								sx={{ mt: 1 }}
								content={{ config: { message: attr.name } }}
							/>
						);
					}
					return null;
				})}
		</>
	);
};

export default ContactDataCollector;
